import { Box, HStack, Icon, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FiClock } from "react-icons/fi";
import { SeV2QuestionDto } from "../../../../../autogen/bff-api";
import { formatDateTime } from "../../../../../common/components/communication/communicationUtils";
import { QuestionStatusChip } from "../../../../../common/components/communication/QuestionStatusChip";
import { TipTap } from "../../../../../common/input/TipTap/TipTap";

export const SupplierQuestionThread = ({ question }: { question: SeV2QuestionDto }) => {
  const { t } = useTranslation();
  return (
    <Box borderWidth="1px" borderColor="smBorder" rounded="lg" overflow="hidden">
      <HStack
        px="4"
        py="3"
        borderBottomWidth="1px"
        borderColor="smBorder"
        justify="space-between"
        align="center"
        spacing="3"
      >
        <Text fontSize="md" fontWeight="semibold" color="smText" minW={0} noOfLines={1}>
          {question.subject}
        </Text>
        <QuestionStatusChip status={question.status} />
      </HStack>

      <Box px="4" py="3">
        <Text fontSize="sm" fontWeight="semibold" color="smText" mb="1">
          {t("Your question")}{" "}
          <Text as="span" fontWeight="normal" color="smMuted">
            · {formatDateTime(question.createdAt)}
          </Text>
        </Text>
        <TipTap content={question.content} editable={false} maxHeight="96" />
      </Box>

      {question.answer ? (
        <Box px="4" py="4" borderTopWidth="1px" borderColor="smBorder" bg="smPrimarySofter">
          <Text fontSize="sm" fontWeight="semibold" color="smChipTealFg" mb="1">
            {t("Answer from the buyer")}{" "}
            <Text as="span" fontWeight="normal" color="smMuted">
              · {formatDateTime(question.answer.answeredAt)}
            </Text>
          </Text>
          <TipTap content={question.answer.content} editable={false} maxHeight="96" />
        </Box>
      ) : (
        <HStack
          px="4"
          py="3"
          borderTopWidth="1px"
          borderColor="smBorder"
          spacing="2"
          color="smMuted"
        >
          <Icon as={FiClock} boxSize="4" />
          <Text fontSize="sm">{t("Waiting for an answer from the buyer")}</Text>
        </HStack>
      )}
    </Box>
  );
};
